<template>
    <div class="nav">
      <div class="toast-pop" v-if="isZm">
       <div>{{zm}}</div> 
      </div>
        <!-- <div class="nav-top" > -->
          <!-- <div @click="allCity()">全国<van-icon :name="arrowDown" /></div> -->
          <!-- <div  @click="filterSystem()">筛选<van-icon :name="arrowDown1" /></div> -->
        <!-- </div> -->
        <!-- 全国城市弹窗 -->
        <van-popup
          v-model="popAllCityShow"
          round
          position="top"
          :style="{ height: '' }">
          <van-tree-select
            :items="citiesList"
             height="360"
            :active-id.sync="activeId"
            :main-active-index.sync="activeIndex"
            @click-item="clickCity"
          />
        </van-popup>
        <!-- 教育类型弹窗 -->
        <van-popup
          v-model="popFilterShow"
          round
          position="top"
          :style="{ height: '' }">
          <div class="nav-pop-type">教育类型</div>
          <van-checkbox-group v-model="result">
            <van-cell-group>
              <van-cell
                v-for="(item, index) in eduTypelist"
                clickable
                :key="item"
                :title="`${item.dictName}`"
                @click="toggle(index)"
              >
                <van-checkbox :name="item.dictValue" ref="checkboxes" slot="right-icon"/>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
         <div class="nav-pop-button" @click="selectEduType()">确 定</div>
        </van-popup>

 

        <div class="nav-list">
          <!-- :sticky-offset-top="20" 吸顶效果 highlight-color="#F63C45" 字母吸顶颜色和右侧字母颜色-->
           <van-index-bar :index-list="indexList"  @select="selectCharacter" highlight-color="#333">
             <div v-for="(item,index) in cellList">
                <van-index-anchor v-if="index==0" :index="item.letter" />
                <van-index-anchor v-else :index="item.letter" />
                <div v-for="(item1,index1) in item.letterList">
                  <van-cell :title="item1.subsystemName" @click="selectEdu(item1.subsystemId)">
                    <span v-if="radio == item1.subsystemId" style="float:right;margin-top: 0.18rem;margin-right:0rem;">
                        <van-radio :name="''+(item1.subsystemId)" v-model="radio"> </van-radio>
                    </span>
                  </van-cell>
                </div>
             </div> 
           </van-index-bar>
        </div>
        <div class="nav-bottom">
          <div class="nav-pop-button1" @click="buyCourse">购 买</div>
        </div>
      
    </div>
</template>
<script>  
import request from '@/utils/request'
import {
    Button,Tab,CellGroup,Cell, IndexBar, IndexAnchor,Radio,
    NavBar,Icon,Popup,Checkbox,CheckboxGroup,TreeSelect,Toast,
    Notify
  } from 'vant';
  export default {
    components: {
      [Button.name]: Button,
      [Tab.name]: Tab,
      [IndexBar.name]: IndexBar,
      [CellGroup.name]: CellGroup,
      [Cell.name]: Cell,
      [IndexAnchor.name]: IndexAnchor,
      [Radio.name]: Radio,
      [NavBar.name]: NavBar,
      [Icon.name]: Icon,
      [Popup.name]: Popup,
      [Checkbox .name]: Checkbox ,
      [CheckboxGroup.name]: CheckboxGroup,
      [TreeSelect.name]: TreeSelect,
      [Toast.name]: Toast,
      [Notify.name]: Notify,
		},
    data(){
      return{
        result: [],
        eduTypelist:[],
        eduTypelist1:[
          {name:'运输企业安全管理人员培训', id:'10001'},
          {name:'施工企业安全管理人员培训', id:'10002'},
          {name:'客货运驾驶员从业再教育', id:'10003'}
        ],
        citiesList:[],
        items:[
           {
            text: '全国',
            children: [
              { text: '全国', id: 999 }
            ]
          },
          {
            text: '直辖市',
            children: [
              { text: '北京', id: 1 },{ text: '上海', id: 2 },{ text: '天津', id: 3 }
            ]
          },
        ],
        areaNo:'',//选择城市id
        isZm:false,
        zm:'',
        isShowPop:false,//是否显示弹框
        activeId: 1,//右侧选中项的 id，支持传入数组(多选)
        activeIndex: 0,//左侧选中项的索引
        activeTab: 0,
        radio: '',
        isSelect:false,
        isDown:true,//全国标识
        isDownOne:true,//筛选标识
        arrowDown:'arrow-down',//全国想想箭头
        arrowDown1:'arrow-down',//筛选相信箭头
        popAllCityShow:false,//全国层是否显示
        popFilterShow:false,//筛选层是否显示
        indexList1: ['A','B','C','D','E'],
        indexList:[],
        cellList:[],
        cellList1:[
          { character:'A',
            subSystemList:[
              {title:'鄂尔多斯两类人员子系统00',no:1},
              {title:'鄂尔多斯两类人员子系统11',no:2},
              {title:'鄂尔多斯两类人员子系统22',no:3},
              {title:'鄂尔多斯两类人员子系统33',no:4},
            ]
          },
        ]

      }
    },
    created() {
			
				function GetQueryString(name) {
				var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
				var r = window.location.search.substr(1).match(reg);
				if (r != null) return unescape(r[2]);
				return null;
			}
			// 调用方法
			if(GetQueryString('openid') != '' &&  GetQueryString('openid') != null){
				// alert(GetQueryString('openid')+'openid');
				localStorage.setItem('openid',GetQueryString('openid'));
			}
      this.getSubsystem();//wap查询子系统列表
      this.getEducationType();//wap获取教育类型
      this.getAreaListInfo();//wap获取城市（只有有子系统的城市才会列出）
    },
    methods: {
      getSubsystem(){ //获取子系统列表
        let _this = this;
        let url = Global.env + Global.apiCore.getSubsystem;
        let dictValues = this.result.join(",");
        let areaNo = this.areaNo;
        return new Promise((resolve, reject) => {
          request({
            url: url,
            method: 'get',
            params:{dictValues:dictValues,areaNo:areaNo}, 
          }).then(response => {          
            if (response.resultCode === '1000') {
              if(response.data){
                _this.indexList = [];
                _this.cellList = response.data;
                response.data.forEach(item => {
                  _this.indexList.push(item.letter)
                });
              }
              return resolve()
            }else{
               Notify(response.resultDesc)
              return reject(response.resultDesc);
            }
          }).catch(error => {
             Notify("网络有误，联系管理员")
              return reject(error);
          })
        })
      },
      getEducationType(){
        let _this = this;
        let url = Global.env + Global.apiCore.getEducationType;
        return new Promise((resolve, reject) => {
          request({
            url: url,
            method: 'get',//查询一般为get
            params:{dictType:'educationType'}, //get
          }).then(response => {          
            if (response.resultCode === '1000') {
              if(response.data){
                _this.eduTypelist = response.data;
              }
              return resolve()
            }else{
              Notify(response.resultDesc)
              return reject(response.resultDesc);
            }
          }).catch(error => {
            Notify("网络有误，联系管理员")
            return reject(error);
          })
        })
      },
      getAreaListInfo(){//wap获取城市（只有有子系统的城市才会列出）
        let _this = this;
        let url = Global.env + Global.apiCore.getAreaListInfo;
        return new Promise((resolve, reject) => {
          request({
            url: url,
            method: 'get',//查询一般为get
          }).then(response => {          
            if (response.resultCode === '1000') {
              if(response.data){
                let dataObj = response.data;
              
                dataObj.forEach((item,index)=>{
                  item.text = item.areaName;
                  item.cities.forEach((item1,index1)=>{
                      item1.id = item1.areaNo;
                      item1.text = item1.areaName;
                  })
                   item.children = item.cities;
                })
                //console.log(dataObj)
                _this.citiesList = dataObj;
              }
              return resolve()
            }else{
              Notify(response.resultDesc)
              return reject(response.resultDesc);
            }
          }).catch(error => {
            Notify("网络有误，联系管理员")
            //_this.$root.tips("网络有误，联系管理员","error")
              return reject(error);
          })
        })
      },
      selectEduType(){
        this.popFilterShow = false;
        this.getSubsystem();
      },
      selectCharacter(zm){
        this.zm = zm;
        this.isZm = true;
        var cancelShowTimer = null;
        cancelShowTimer && window.clearTimeout(cancelShowTimer);
        cancelShowTimer = setTimeout(() => {
          this.isZm = false;
        }, 3000);
      },
      // 返回一个特定的 DOM 节点，作为挂载的父节点
      getContainer() {
        return document.querySelector('.my-container');
      },
      clickCity(obj){
        this.popAllCityShow = false;
        this.areaNo = obj.areaNo;
        this.getSubsystem();
       // console.log(obj)
      },
      allCity(){
        //this.arrowDown = this.isDown? 'arrow-up' : 'arrow-down'
        // this.isDown = !this.isDown;
        // if(this.isDown){
        //   this.popAllCityShow = false;
        // }else{
        //   this.popAllCityShow = true;
        // }
         this.popAllCityShow = true;
      },
      filterSystem(){
       // this.arrowDown1 = this.isDownOne? 'arrow-up' : 'arrow-down'
        // this.isDownOne = !this.isDownOne;
        // if(this.isDownOne){
        //   this.popFilterShow = false;
        // }else{
        //   this.popFilterShow = true;
        // }
         this.popFilterShow = true;
      },
      
      toggle(index) {
        this.$refs.checkboxes[index].toggle();
       // console.log(this.result)
      },
      selectEdu(n){
        //alert(n)
        //this.isSelect = !this.isSelect;
        this.isSelect = true;
        if(this.isSelect){
          this.radio = n+'';
        }
      },
      buyCourse(){//购买
        let _this = this;
        if(this.radio){
          let _this = this;
          let url = Global.env + Global.apiCore.getAppIsFee;
          return new Promise((resolve, reject) => {
            request({
              url: url,
              method: 'get',//查询一般为get
              params:{subsystemId:this.radio}, //get
            }).then(response => {          
              if (response.resultCode === '1000') {
                if(response.data){
                  let dataObj = response.data;
                    console.log('lyb',dataObj.isSetting)

                  dataObj.isFee == 2;
                  if(dataObj.isFee == 1){
                    //1、需要 2、不需要 3、子系统没有配置
                    // 缴费模式 * 1正常模式（默认使用期限一年） * 2任务模式（用户可选择按月、半年、一年购买，到期结束） * 3、考试模式（使用期限以完成证书考试为标准
                    this.$router.push({name:'PaymentOrder',query:{subsystemId:dataObj.subsystemId,costMode:dataObj.costMode} })
                    //子系统配置学习时长范围 to 新支付订单页面
                    if(dataObj.isSetting=='1')
                    {
                      this.$router.push({name:'paymentOrderContinueEduction',query:{subsystemId:dataObj.subsystemId}})
                    }else{
                      this.$router.push({name:'PaymentOrder',query:{subsystemId:dataObj.subsystemId,costMode:dataObj.costMode} })
                    }

                  }else{
                    Notify("该系统无需缴费")
                  }

                  //子系统配置学习时间范围打开新支付界面

                }
                return resolve()
              }else{
                Notify(response.resultDesc)
                return reject(response.resultDesc);
              }
            }).catch(error => {
              Notify("网络有误，联系管理员")
              return reject(error);
            })
          })
          
        }else{
          Notify("请选择子系统")
        }
      },
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss">
  .nav{
     margin: 0 0;
    .nav-top{
      position: fixed;
      z-index: 2;
      top: 0;
      height: .8rem;
      background: #fff;
      width: 100%;
      display: flex;
      font-size: .34rem;
      justify-content:space-around;
      align-items: center;
    }
    //顶部导航 下三角
    .van-icon-arrow-down{
      margin-top: .03rem;
      position: absolute;
    }
    //子系统列表+右侧字母
    .van-cell {
        font-size: .4rem;
        line-height: .6rem;
        background-color: #fff;
        border-bottom: 1px solid #f7f8fa;
       // padding-right: 1rem;
    }
    .van-cell__value {
        overflow: initial;
    }
    .nav-list{
      margin-top:.2rem;margin-bottom: 1.2rem;
      .van-cell {
         padding-right: 1rem;
      }
    }
    .van-index-anchor{
      padding: .3rem;
      font-size: .3rem;
      line-height: 0.2rem;
      background: #f7f8fa;
    }
    .van-index-anchor--sticky {
         top: .2rem;
    }
    .van-index-bar__index {
        font-size: .28rem;
        line-height: .46rem;
        padding: .056rem .22rem;
    }
  
    //右侧字母
    .van-index-bar__sidebar{
      right: .2rem;
    }
    //教育类型
    .nav-pop-type{
      font-size: .34rem;
      padding: .3rem;
    }
    .van-checkbox-group{
      padding: .14rem;
    }
    .van-radio__icon--checked .van-icon {
      background-color: #F63C45;
      border-color: #F63C45;
    }
    .van-checkbox__icon--checked .van-icon{
      background-color: #F63C45;
      border-color: #F63C45;
    }
    .van-cell__title span{
      font-size: .34rem;
      width: 6rem;
      display: inline-block;
    }
    .van-checkbox__icon,.van-radio__icon{
      font-size: .3rem;
    }
    .nav-pop-button{
      border: 1px solid #F63C45;
      background: #F63C45;
      color: #fff;
      font-size: .34rem;
      line-height: .7rem;
      width: 5.2rem;
      border-radius: .6rem;
      display: flex;
      justify-content: center;
      margin: .28rem 1.1rem;
    }

    .nav-pop-button1{
      border: 1px solid #F63C45;
      background: #F63C45;
      color: #fff;
      font-size: .34rem;
     width: 92.5%;
     height: 0.82rem;
     line-height: 0.82rem;
      display: flex;
      justify-content: center;
    }
    //全国城市布局
    .van-sidebar-item--select{
      height: 1.24rem;
      .van-sidebar-item__text{
        font-size: .28rem;
        line-height: .88rem;
      }
    }
    .van-tree-select__item{
      font-size: .28rem;
      line-height: 1.24rem;
      height: 1.24rem;
    }
    .van-tree-select__nav-item{
      font-size: .28rem;
      line-height: .88rem;
    }
   
    //底部
    .nav-bottom{
        position: fixed;
        display: flex;
        z-index: 0;
        bottom: 0;
        height: 1.2rem;
        background: #F3F3F4;
        width: 100%;
        font-size: .34rem;
        -ms-flex-pack: distribute;
        justify-content: space-around;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }
    
    .toast-pop{}
    .toast-pop div{
      position: fixed;
      width: 1.6rem;
      height: 1.4rem;
      background: #F63C45;
      top: 40%;
      left: 50%;
      transform: translate(-50%);      
      z-index: 99;
      color: #fff;
      text-align: center;
      border-radius: 5px;
      line-height: 1.4rem;
      animation:myfirst 3s;
    }
  }
  @keyframes myfirst{
    from {background:#F63C45;}
    to {background:#ff979c;}
  }

  @-moz-keyframes myfirst {
    from {background:#F63C45;}
    to {background:#ff979c;}
  }

  @-webkit-keyframes myfirst{
    from {background:#F63C45;}
    to {background:#ff979c;}
  }
  @-o-keyframes myfirst{
    from {background:#F63C45;}
    to {background:#ff979c;}
  }
   //字母提示
    .van-toast{
     // background-color: #f63c45!important;
      font-size: .8rem;
      height: 1rem;
    }
    .van-notify {
      font-size: .3rem;
      line-height: .7rem;
    }
    
</style>